import React from "react";
import RenderHtml from "react-native-render-html";
import { useWindowDimensions, StyleSheet } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";

export const CustomHtmlContent = ({ htmlString }: { htmlString: string }) => {
  if (!htmlString) return null;
  const { width } = useWindowDimensions();

  // Check if the content contains HTML tags
  const hasHtmlTags = /<[^>]*>/g.test(htmlString);

  if (hasHtmlTags) {
    return (
      <RenderHtml
        contentWidth={width - 64} // Account for padding
        source={{ html: htmlString }}
        tagsStyles={{
          body: {
            fontSize: 14,
            color: "#475569",
            lineHeight: 20,
            margin: 0,
            padding: 0,
          },
          p: {
            margin: 0,
            marginBottom: 8,
          },
          div: {
            margin: 0,
          },
          ul: {
            marginTop: 0,
            marginBottom: 8,
          },
          li: {
            marginBottom: 4,
          },
        }}
      />
    );
  } else {
    // If no HTML tags, render as plain text
    return <CustomText style={styles.frameworkDescription} text={htmlString} useTranslationText={false} />;
  }
};

const styles = StyleSheet.create({
  frameworkDescription: {
    fontSize: 14,
    color: "#475569",
    lineHeight: 20,
  },
});
